import { Alert, SkeletonRows } from "@station/ui";
import { createFileRoute } from "@tanstack/react-router";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { ExpenseForm } from "../../../../features/expenses/expense-form.js";
import { useExpense } from "../../../../features/expenses/queries.js";
import {
  ExpensesPage,
  useExpensePermissions,
  useExpensesCrumb,
} from "../../../../features/expenses/shared.js";
import { errorMessage } from "../../../../lib/errors.js";

export const Route = createFileRoute("/_app/giderler/$id/duzenle")({ component: EditExpensePage });

function EditExpensePage(): ReactElement {
  const { t } = useTranslation();
  const { id } = Route.useParams();
  const crumb = useExpensesCrumb("/giderler");
  const permissions = useExpensePermissions();
  const expense = useExpense(id);

  return (
    <ExpensesPage
      title={t("expenses.form.editTitle")}
      breadcrumb={[crumb, { label: t("expenses.form.editTitle") }]}
    >
      {({ companyId }) =>
        expense.error ? (
          <Alert tone="danger">{errorMessage(expense.error)}</Alert>
        ) : !expense.data ? (
          <SkeletonRows rows={6} />
        ) : !permissions.canManage ? (
          <Alert tone="info">{t("expenses.form.noPermission")}</Alert>
        ) : expense.data.status !== "DRAFT" ? (
          // Onaylanmış gider DEĞİŞTİRİLEMEZ; düzeltme İPTALdir (ters fiş + açık kalem VOID).
          <Alert tone="warning">{t("expenses.form.onlyDraftEditable")}</Alert>
        ) : (
          <ExpenseForm key={expense.data.id} companyId={companyId} expense={expense.data} />
        )
      }
    </ExpensesPage>
  );
}
